(() => {
  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  const REVISION = '2023-12-15';

  const subscribe = async ({ email, variantId, companyId }) => {
    if (!email || !variantId || !companyId) {
      throw new Error('notify-me: missing email, variant or company id');
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email } } },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` },
          },
        },
      },
    };

    const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error(`notify-me: Klaviyo responded ${response.status}`);
  };

  window.NuggetNotifyMe = { subscribe };
})();
